declare var window: any;

export class DynamicEnvironment {
    public get environment() {
        return window.config; 
    }
}


// WEBPACK FOOTER //
// ./src/environments/dinamic-environment.ts